<template>
    <!-- 中心优势  -->
    <div class="honour">
        <h2 class="title">中心荣誉</h2>
        <div class="text">
            <p class="section">
                “双优云桥”教育服务中心，为首都师范大学京疆学院获得中共中央、国务院颁授的“全国脱贫攻坚先进集体”称号做出了巨大贡献。获得教育部副部长亲笔批示嘉奖。入选教育部第三届和第五届“省属高校精准帮扶典型项目”，同时作为唯一一所高校项目，入选国家发改委“社会领域公共服务助力脱贫攻坚典型案例”。所实施项目作为首都师范大学助推教育均衡发展、巩固脱贫攻坚成果、接续乡村振兴战略的重点工作，被写入了《首都师范大学“十四五”时期发展规划（2021—2025）》和《北京市智力支援“十四五”规划》。2022年，作为北京市唯一入选项目，被教育部评选为“经典润乡土计划”重点项目，并受邀作为北京教育公益代表参加中国国际服务贸易交易会，北京市委、市政府主要领导和北京市教育两委领导莅临展位听取了汇报并给予高度肯定。
            </p>
        </div>
        <div class="honour-lists">
            <ul class="horizontal-list flex-layout">
                <li v-for="(item,index) in horizontalList" :key="index" class="horizontal-item honour-item csp">
                    <img :src="item.medal" alt="" class="item-img">
                    <p class="item-title"><span>{{item.time}}</span>{{item.title}}</p>
                </li>
            </ul>
            <ul class="vertical-list flex-layout">
                <li v-for="(item,index) in verticalList" :key="index" class="vertical-item honour-item csp">
                    <img :src="item.document" alt="" class="item-img">
                    <p class="item-title"><span>{{item.time}}</span>{{item.title}}</p>
                </li>
            </ul>
            <div class="pagination">
                <div class="dot" v-for="(dot,index) in 3" :key="index" :class="{'active':activeDot == index}"
                    @click="activeDot=index"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeDot: 0,
                horizontalList: [{
                    medal: require("../../assets/general/medal.png"),
                    time: '2021年2月',
                    title: '荣获”全国脱贫攻坚先进集体“'
                }, {
                    medal: require("../../assets/general/medal.png"),
                    time: '2021年2月',
                    title: '荣获”全国脱贫攻坚先进集体“'
                }, {
                    medal: require("../../assets/general/medal.png"),
                    time: '2021年2月',
                    title: '荣获”全国脱贫攻坚先进集体“'
                }, {
                    medal: require("../../assets/general/medal.png"),
                    time: '2021年2月',
                    title: '荣获”全国脱贫攻坚先进集体“'
                }, {
                    medal: require("../../assets/general/medal.png"),
                    time: '2021年2月',
                    title: '荣获”全国脱贫攻坚先进集体“'
                }],
                verticalList: [{
                        document: require("../../assets/general/document.png"),
                        time: '2021年2月',
                        title: '荣获”全国脱贫攻坚先进集体“'
                    },
                    {
                        document: require("../../assets/general/document.png"),
                        time: '2021年2月',
                        title: '荣获”全国脱贫攻坚先进集体“'
                    },
                    {
                        document: require("../../assets/general/document.png"),
                        time: '2021年2月',
                        title: '荣获”全国脱贫攻坚先进集体“'
                    },
                    {
                        document: require("../../assets/general/document.png"),
                        time: '2021年2月',
                        title: '荣获”全国脱贫攻坚先进集体“'
                    }
                ]
            }
        }
    }
</script>

<style lang="less" scoped>
    .honour {
        // padding: 0 0 80%;
        // background-image: url("../../assets/business/bg.png");
        // background-repeat: no-repeat;
        // background-position: bottom;

        .title {
            font-size: 20px;
            padding: 3.3% 0;
            text-align: center;
        }

        .text {
            font-size: 12px;
            line-height: 2;
            font-weight: 300;
            padding: 0 5.2%;

            .section {
                text-indent: 2em;
                margin-bottom: 1.5%;
            }
        }

        .honour-lists {
            margin-top: 2.5%;
            padding: 0 5.2% 8%;
            background-image: url("../../assets/general/honour-bg.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: bottom;

            .horizontal-list,
            .vertical-list {
                flex-wrap: wrap;

                .honour-item {
                    border: 1px solid #dcdcdc;
                    margin-right: 3.9%;
                    margin-bottom: 3.9%;
                    transition: 1s all;

                    &:hover {
                        box-shadow: 0px 2px 35px 2px rgba(30, 19, 15, 0.11);
                    }
                }

                .horizontal-item {
                    width: calc((100% - 4.3% * 2) / 3);

                    &:nth-child(3n) {
                        margin-right: 0;
                    }

                }

                .vertical-item {
                    width: calc((100% - 4.2% * 3) / 4);

                    &:nth-child(4n) {
                        margin-right: 0;
                    }
                }

                .item-img {
                    width: 100%;
                }

                .item-title {
                    font-size: 12px;
                    font-weight: 300;
                    line-height: 3.75;
                    text-align: center;
                    background-color: #fff;

                    span {
                        margin-right: 5%;
                    }
                }
            }
        }

        .pagination {
            text-align: center;
            margin-top: 7%;

            .dot {
                display: inline-block;
                width: 9px;
                height: 9px;
                background-color: #2C79FF;
                border-radius: 50%;
                position: relative;
                margin-right: 14px;

                &:last-child {
                    margin-right: 0;
                }

                &.active::after {
                    content: " ";
                    position: absolute;
                    width: 17px;
                    height: 17px;
                    border: 1px solid #2c79ff;
                    border-radius: 50%;
                    left: -5px;
                    top: -5px;
                }
            }
        }


        @media screen and (min-width:1250px) {
            .title {
                font-size: 26px;
            }

            .text {
                font-size: 15px;
            }

            .honour-lists {

                .horizontal-list,
                .vertical-list {

                    .item-title {
                        font-size: 14px;
                    }
                }
            }

        }

        @media screen and (min-width:1680px) {
            .title {
                font-size: 36px;
            }

            .text {
                font-size: 20px;
            }

            .honour-lists {

                .horizontal-list,
                .vertical-list {
                    .item-title {
                        font-size: 16px;
                    }
                }
            }
        }


    }
</style>